import React from 'react';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> & {
	headingLevel?: HeadingLevel;
};

export const Heading: React.FC<HeadingProps> = ({
	headingLevel = 3,
	className,
	children,
}) => {
	const HeadingTag = `h${headingLevel}` as keyof React.JSX.IntrinsicElements;

	return <HeadingTag className={className}>{children}</HeadingTag>;
};
